<template>
  <v-row class="send-email-tab">
    <v-col cols="12">
      <v-card elevation="0" color="transparent">
        <v-card-title class="pl-0 pt-0 pb-0">
          You Can Send Bulk Email From Here
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card class="deposit-form" color="transparent">
        <v-row dense>
          <v-col cols="12" sm="12" md="10" lg="9" class="mb-2">
            <fieldset>
              <legend>Category</legend>
              <v-select solo :items="slots" v-model="selectedCategory" append-icon="mdi-chevron-down"
                label="Select Send Email Category" class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>

          <v-col cols="12" sm="12" md="10" lg="9" class="mb-2"
            v-if="selectedCategory === 'Select Custom Email Address'">
            <fieldset class="custom-select-emailist">
              <legend>Custom Email Addresses(Recipients: {{ customEmails?.length }})</legend>

              <v-autocomplete v-model="customEmails" :items="allEmailsCustom" item-text="text" item-value="value"
                label="Select Client Email Addresses" multiple chips deletable-chips single-line solo
                class="custom-select" :loading="loadingRecipients" :disabled="loadingRecipients" />
            </fieldset>
          </v-col>

          <v-col cols="12" sm="12" md="10" lg="9" class="mb-2" v-else>
            <fieldset class="custom-select-emailist">
              <legend>{{ selectedCategory }} Email Addresses(Recipients: {{ customEmails?.length }})</legend>

              <v-autocomplete v-model="customEmails" :items="allemails" item-text="text" item-value="value"
                label="Select Client Email Addresses" multiple chips deletable-chips single-line solo
                class="custom-select" :loading="loadingRecipients" :disabled="loadingRecipients" />
            </fieldset>
          </v-col>

          <v-col cols="12" sm="12" md="10" lg="9" class="mb-2">
            <fieldset>
              <legend>Subject</legend>
              <v-text-field v-model="emailSubject" label="Enter Subject" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card class="pr-1 custom-tiny-mce" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
        <tiny-mce-editor-view v-model="emailContent" ref="tinyMCE"></tiny-mce-editor-view>
      </v-card>
    </v-col>
    <v-col cols="12" class="mt-5" v-if="$canRoute('send-email') === 1">
      <v-btn large :loading="loading" :disabled="loading" tile elevation="0" class="text-capitalize btn-account"
        color="greenMain" @click="submitForm">
        Send
      </v-btn>
      <v-btn large tile elevation="0" class="ml-3 text-capitalize btn-account" color="#FF567F" @click="resetForm">
        Reset
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>

import tinyMceEditorView from "@/components/MarketingTool/TinyMceEditorView";
import { mapActions, mapState } from "vuex";
import { MARKETINGDATA__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  components: { tinyMceEditorView },
  data() {
    return {
      loading: false,
      loadingRecipients: false,
      slots: [
        "Select Custom Email Address",
        "All Clients",
        "All Partners",
        "All MAM Manager",
        "All PAAM Manager",
        "All Investor",
        "All Low Balance Account",
        "All Inactive Accounts"
      ],

      customEmails: [],
      emailSubject: "",
      emailContent: "",
      selectedCategory: "",
    };
  },

  computed: {
    ...mapState("marketingdata", ["allemails", "allEmailsCustom"]),
  },

  watch: {
    async selectedCategory(val) {
      this.customEmails = [];
      if (!val) return;

      this.loadingRecipients = true;
      try {
        const list = await this[MARKETINGDATA__ACTIONS.GETEMAILSBYCATEGORY]({ category: val });
        if (val !== "Select Custom Email Address") {
          this.customEmails = (list || []).map(x => x.value);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingRecipients = false;
      }
    }
  },

  methods: {
    ...mapActions("marketingdata", [
      MARKETINGDATA__ACTIONS.SENDEMAIL,
      MARKETINGDATA__ACTIONS.GETEMAILSBYCATEGORY,
      MARKETINGDATA__ACTIONS.GETALLEMAIL
    ]),

    async submitForm() {
      try {
        this.loading = true;

        if (!this.selectedCategory || !this.emailSubject) {
          toast.error("Please fill in all required fields.");
          return;
        }

        if (
          this.selectedCategory === "Select Custom Email Address" &&
          (!Array.isArray(this.customEmails) || this.customEmails.length === 0)
        ) {
          toast.error("Please select at least one email address.");
          return;
        }

        const payload = {
          category: this.selectedCategory,
          emails: Array.isArray(this.customEmails) ? this.customEmails : [],
          subject: this.emailSubject,
          content: this.emailContent,
        };

        await this[MARKETINGDATA__ACTIONS.SENDEMAIL](payload);
        
        this.resetForm();
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    resetForm() {
      this.selectedCategory = "";
      this.customEmails = [];
      this.emailSubject = "";
      this.emailContent = "";

      this.$nextTick(() => {
        if (this.$refs.tinyMCE && this.$refs.tinyMCE.resetEditor) {
          this.$refs.tinyMCE.resetEditor();
        }
      });
    },
  },

  async created() {
    await this[MARKETINGDATA__ACTIONS.GETEMAILSBYCATEGORY]({
      category: "Select Custom Email Address"
    });
    await this[MARKETINGDATA__ACTIONS.GETALLEMAIL]();
  }
};

</script>

<style scoped>
.custom-select-emailist {
  min-height: 150px;
  overflow: auto !important;
  margin-top: 15px;
}
</style>